const IntegrationSystemIdConstants = {
    SendGrid: "c34e1a14-2473-4846-b2b8-c6bccd736bb0",
    Xero: "d87b2a15-4729-5246-c3c9-d7cdd837bc80",
    Microsoft365: "e98c3b16-5830-6357-d4da-e8dee948cd91",
    GoogleWorkspace: "f09d4c27-6941-7468-e5eb-f9eff059de02",
    PurePro: "a1b2c3d4-7052-8579-f6fc-0a000160ef13",
  };
  export default IntegrationSystemIdConstants;
  